import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class ProjectPlanPhaseLookupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhase-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhase-001";

        let fk = {};
        fk["ProjectPlanUSID"] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phases",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification()
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ProjectPlanPhaseLookupEnterpriseComponent;